export const tr = {
    continue: 'Devam edilsin mi?',
    'pay-will-not-apply-for-campaigns': 'Seçilen işlem kampanyalar için geçersiz:'
};
